module.exports = __webpack_public_path__ + "static/img/ymh5.1d8b6d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ymh5.png
// module id = 41Op
// module chunks = 0